export default __webpack_public_path__ + "static/media/mood_swings@3x.637097b3.jpg";